<div id="container-banner" [ngClass]="classHead">
  <div id="background-gradient">
    <div id="circle">
      <ion-img [src]="configCircleBanner.iconImg"></ion-img>
    </div>
  </div>
</div>
